import * as cart from '@shopify/theme-cart';

const selectors = {
  checkboxInputs: '[data-upsell-checkbox]',
}

const nodeSelectors = {
  checkboxInputs: document.querySelectorAll(selectors.checkboxInputs),
};

export default function init ({ el, context }) {
  const thisForm = el
  let subTotal = 0,
    listOfProducts = [];

  const checkboxes = document.querySelectorAll(".custom-checkbox-container"),
    subTotalProductsEl = document.querySelector(".bought-together__summary__note__product-name"),
    selectedProductNames = document.querySelectorAll(".bought-together__product__details__name"),
    subTotalProductNamesContainer = document.querySelector(".bought-together__summary__note"),

    productPrices = document.querySelectorAll(".bought-together__product__details__price"),
    subTotalPriceEl = document.querySelector(".bought-together__summary__price__value"),
    
    goToCheckoutBtn = document.querySelector(".go-to-checkout");


  checkboxes.forEach((checkbox, index) => {
    checkbox.addEventListener("click", (e) => {
      isBoxChecked(e, index);
    });
  });

  function isBoxChecked(e, index) {
    let checkedStatus = e.target.checked;
    let thisButton = e.target
    if (checkedStatus !== undefined) {
      updateSubtotal(index, checkedStatus);
      updateDataAttr(thisButton, checkedStatus);
      handleSubtotalProductNames(selectedProductNames[index].innerHTML,checkedStatus);
    }
  }

  function updateDataAttr(thisButton, checkedStatus) {
    if(checkedStatus){
      thisButton.removeAttribute('data-selected')
    } else {
      thisButton.addAttribute('data-selected')
    }
  }

  function updateSubtotal(index, checkedStatus) {
    let selectedProdPrice = parseInt(productPrices[index].dataset.productPrice);
    checkedStatus ? (subTotal += selectedProdPrice) : (subTotal -= selectedProdPrice);
    subTotalPriceEl.innerHTML = subTotal / 100;
  }

  function handleSubtotalProductNames(prodName, checkedStatus) {
    checkedStatus ? addProdToList(prodName) : removeProdFromList(prodName);

    function addProdToList(prodName) {
      listOfProducts.push(prodName);
      updateProductNames();
    }

    function removeProdFromList(prodName) {
      listOfProducts.indexOf(prodName) > -1 ? listOfProducts.splice(listOfProducts.indexOf(prodName), 1) : console.log("nothing to remove");
      updateProductNames();
    }

    function updateProductNames() {
      console.log(listOfProducts);
      if (listOfProducts.length > 1) {
        subTotalProductNamesContainer.style.display = "block";
        subTotalProductsEl.innerHTML = listOfProducts.join(" and ");
      } else if (listOfProducts.length === 1) {
        subTotalProductNamesContainer.style.display = "block";
        subTotalProductsEl.innerHTML = listOfProducts.join("");
      } else if (listOfProducts.length <= 0) {
        subTotalProductNamesContainer.style.display = 'none';
      }
    }
  }

  const addProductToCart = async (id, quantity, properties) => {
    return await cart.addItem(id, { quantity, properties })
  }

  for (var i = nodeSelectors.checkboxInputs.length - 1; i >= 0; i--) {
    nodeSelectors.checkboxInputs[i].addEventListener('change', (event) => {
      var thisCheckbox = event.currentTarget
      thisCheckbox.setAttribute('data-selected', true)
    });
  }

  thisForm.addEventListener('submit', async (event) => {  
    event.preventDefault();
    var selectedVariants = thisForm.querySelectorAll('[data-upsell-checkbox][data-selected]')
    for (var i = selectedVariants.length - 1; i >= 0; i--) {
      var id = parseInt(selectedVariants[i].value)
      var qty = 1
      var properties = {

      }
      
      var addedResponse = await addProductToCart(id, qty, properties)
      
    }
    document.dispatchEvent(new Event('addedToCart'))
  });
}